import axios from 'axios'

import {DistributedCacheResponse} from '../../types/DistributedCache'

import {Api} from '@settings/api'

export const GET_PINNED_GLOBAL_MEASUREMENT_NAME_KEY = 'pinGlobalMeasurementName'

export async function getPinnedGlobalMeasurementName(
  keyIdentifier: string
): Promise<DistributedCacheResponse> {
  try {
    const path = '/distributeduserstorage'
    const response = await Api.axiosInstance.get<DistributedCacheResponse>(path, {
      params: {keyIdentifier}
    })
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      return {keyIdentifier}
    }

    throw error
  }
}
